/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { CheckmarkOutline } from '@carbon/react/icons';
import { Modal } from 'carbon-components-react';
import React from 'react';

import ShieldImg from '@ibm-watson/shared/assets/images/shield_iso.svg';
import { Noop } from '../../../../ts';

const strings = {
  MODAL_LABEL: 'Upgrade',
  MODAL_HEADING: 'Get more out of Assistant',
  ENTERPRISE_LIST_1: 'Cost effective at scale',
  ENTERPRISE_LIST_2:
    'Ensure additional reliability and control with dedicated containers for data storage',
  ENTERPRISE_LIST_3:
    'Export, analyze and share logs anywhere you want via connected webhooks or API endpoints',
  ENTERPRISE_LIST_4: 'Gain access to 90-day analytics retention period',
  ENTERPRISE_LIST_5: 'Conduct regression testing without increasing MAU usage',
  ENTERPRISE_CONTACT:
    'Contact our sales team to start your transition to our Enterprise plan.',
  CONTACT: 'Contact for Enterprise',
  CANCEL: 'Cancel'
};

export interface EnterpriseUpgradeModalProps {
  onClose: Noop;
  onConfirm: Noop;
}

const EnterpriseUpgradeModal: React.FC<EnterpriseUpgradeModalProps> = ({
  onClose,
  onConfirm
}) => {
  const checkList = [
    'ENTERPRISE_LIST_1',
    'ENTERPRISE_LIST_2',
    'ENTERPRISE_LIST_3',
    'ENTERPRISE_LIST_4',
    'ENTERPRISE_LIST_5'
  ];

  return (
    <Modal
      open
      size="sm"
      className="EnterpriseUpgradeModal"
      modalLabel={strings.MODAL_LABEL}
      modalHeading={strings.MODAL_HEADING}
      preventCloseOnClickOutside
      primaryButtonText={strings.CONTACT}
      secondaryButtonText={strings.CANCEL}
      onRequestSubmit={onConfirm}
      onRequestClose={onClose}>
      <div className="UpgradeModal__body">
        <div>
          <p className="UpgradeModal__text">{strings.ENTERPRISE_CONTACT}</p>
          <ul className="UpgradeModal__list">
            {checkList.map(item => (
              <li key={item}>
                <CheckmarkOutline size={16} />
                {strings[item]}
              </li>
            ))}
          </ul>
        </div>
        <div className="UpgradeModal__image">
          <img src={ShieldImg} alt="" />
        </div>
      </div>
    </Modal>
  );
};

export default EnterpriseUpgradeModal;
